/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const RubricAnalyticsDataRowParser = 
/* #__PURE__ */ parsers.object([
    ['itemId', codecNumber, 'item_id'],
    ['multiplier', codecNumber],
]);
export class RubricAnalyticsDataRow extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return RubricAnalyticsDataRowParser.decode(input).map(res => new RubricAnalyticsDataRow(res));
    }
    static unsafeDecode(input) {
        return RubricAnalyticsDataRow.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RubricAnalyticsDataRowParser.encode(data);
    }
    static schema() {
        return RubricAnalyticsDataRowParser.schema();
    }
}
